function generateEventID(length) {
	var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789'.split("");
	var b = [];
	for (var i = 0; i < length; i++) {
		var j = (Math.random() * (a.length - 1)).toFixed(0);
		b[i] = a[j];
	}
	return b.join("");
}
document.addEventListener('click',function(event){
    if(event.target.matches('#cart-sidebar-checkout, #cart-checkout, #cart-checkout-top')){
        localStorage.setItem('checkoutVisited', 1)
        $.ajax({
            type    : 'GET',
            url     : '/cart.js',
            dataType: 'json'
        }).done(cart => {
            if(cart.items.length > 0){
                let content_ids = [];
                let content_name = [];
                $.each(cart.items, function(index,value){
                    content_ids.push(value.variant_id);
                    content_name.push(value.product_title);
                    if(index == cart.items.length - 1){
                        let event_id = generateEventID(36);
                        window.arrayFBPixelTrack && arrayFBPixelTrack.forEach(function(element,index){
                            otfbq(`${element}`, 'InitiateCheckout',{
                                content_type: 'product_group',
                                content_ids: content_ids,
                                currency:Shopify.currency.active,
                                value:parseFloat(cart.total_price)/100,
                                num_items: cart.item_count ,
                                content_name:content_name
                            },event_id);
                        })
                            window.trackEventFBConversionAPI && trackEventFBConversionAPI($,{
                                "action": "InitiateCheckout",
                                "event_id": event_id,
                                "event_source_url": fb_pageURL,
                                "content_ids":content_ids,
                                "content_type":'product_group',
                                "num_items": cart.item_count ,
                                "value":parseFloat(cart.total_price)/100,
                                "content_name": content_name,
                                "currency": Shopify.currency.active ,
                                "pixels": arrayFBPixelTrack,
                                "shop":Shopify.shop
                            });
                    }
                })
            }
        })

    }
});
// global.js
function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}
function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI && model.modelViewerUI.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}
// 更新购物车赠品问题，后台配置将赠品去掉，修复前台原来购物车有该赠品依然存在的问题
window.updateCartGift = function(cart, callback) {
    if (cart && cart.items && Array.isArray(cart.items)) {
        if (window.promotionSettings && window.promotionSettings.gwp) {
            // 礼品赠送逻辑
            var gwp = window.promotionSettings.gwp;
            var giftList = [];
            gwp.map ( x => {
                if (x.gifts && x.gifts.length) {
                    giftList.push(x.gifts[0].handle);
                }
            })
            giftList.length && cart.items.map(x => {
                if (x.properties && x.properties['_gift_product'] == 'yes' && giftList.indexOf(x.handle) == -1) {
                    Shopify.removeItem(x.variant_id, '', (res) => {
                        $('[data-cart-remove-id="'+ x.variant_id +'"]').parents('.cart-item').remove();
                    });
                }
                if (x.properties && x.properties['_gift_product'] == 'yes' && x.quantity > 1) {
                    Shopify.changeItem && Shopify.changeItem(x.variant_id, 1, '', (res) => {
                        var _parents = $('[data-cart-remove-id="'+ x.variant_id +'"]').parents('.cart-item');
                        var _price = _parents.find('.cart-item-total').attr('data-price') * 1 / 100;
                        _price = Math.ceil(_price*Shopify.currency.rate).toFixed(2);
                        _parents.find('.cart-item-total .cart-item-value .etrans-money').html(window.currencySymbol + _price);
                    });
                }
            })
        }
    }
}
window.minimumCartAmount = function(type) {
    let result = 0;
    if (window.promotionSettings && window.promotionSettings.gwp) {
        // 礼品赠送逻辑
        var gwp = window.promotionSettings.gwp;
        var minimum = [];
        gwp.map ( x => {
            minimum.push(x.minimumCartAmount * 100);
        })
        if (minimum.length) {
            type == 'min' ? result = Math.min(...minimum) : (result = Math.max(...minimum));
        }

    }
    return result;
}
window.updateGift = function(cart) {
    var minimum = window.minimumCartAmount('min');
    let status = (cart.total_price / Shopify.currency.rate) > minimum;
    if(window.freeGiftRemoved == false && status){
        if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
            window.cart_clear = false;
            window.promotionValidate && window.promotionValidate();
        }
    }
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
            if ((typeof callback) === 'function') {
                callback(cart);
                window.updateCartGift(cart, callback);
            } else {
                Shopify.onCartUpdate(cart);
            }
            window.updateGift(cart);
            window.cartObj = cart;
        });
}

Shopify.onCartUpdate = function(cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(variant_id, quantity, is_free_gift, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity='+quantity+'&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            var free_gift_present = false;
            var item_key = '';
            for(var i=0; i<cart.items.length; i++){
                var cart_item = cart.items[i];
                if(cart_item.properties['_gift_product'] == 'yes'){
                  free_gift_present = true;
                  item_key = cart_item.key;
                }
            }
            var minimum = window.minimumCartAmount('min');
            var hasAu = Shopify.routes.root.includes('-au');
            var rate = hasAu ? 1 : Shopify.currency.rate;
            if((cart.total_price / rate) > minimum || free_gift_present){
                if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
                  window.cart_clear = false;
                  window.promotionValidate && window.promotionValidate();
                }
            }
            setTimeout(function(){
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    Shopify.onCartUpdate(cart);
                }
            }, 3000);

        },
        error: function(XMLHttpRequest, textStatus) {
            if (XMLHttpRequest.status === 400) {
                location.href = location.href;
            }
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.removeItem = function(variant_id, is_free_gift, callback) {
    if (!variant_id) {
        callback && callback();
        return false;
    }
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=0&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            if(is_free_gift == 'Yes'){
                window.freeGiftRemoved = true;
            } else {
                window.freeGiftRemoved = false;
            }
            if(window.freeGiftRemoved == false){
                if(window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
                  window.cart_clear = false;
                  window.promotionValidate && window.promotionValidate(cart);
                }
            }
            setTimeout(function(){
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    Shopify.onCartUpdate(cart);
                }
            }, 3000);

        },
        error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.addItem = function(variant_id, qty, callback, input = null, dom) {
    var quantity = qty || 1;
    var target = document.querySelector('[data-quickshop] .is-loading') || document.querySelector('[data-btn-addtocart].is-loading');
    var data = {
        quantity: quantity,
        id: variant_id
    }
    if (dom.parents('form').find('[name="properties[_is_final_sale]"]').length) {
        data.properties = {}
        data.properties['_is_final_sale'] = 'yes'
    }
    if (dom.parents('form').find('[name="properties[_is_final_mb]"]').length) {
        data.properties['_is_final_mb'] = 'yes'
    }
    if (dom.parents('form').find('[name="properties[_is_final_sale_bgf]"]').length) {
        if (!data.properties) {
            data.properties = {}
        }
        data.properties['_is_final_sale_bgf'] = 'yes'
    }
    // if (dom.parents('form').find('[name="properties[_gift_box]"]').length) {
    //     if (!data.properties) {
    //         data.properties = {}
    //     }
    //     data.properties['_gift_box'] = 'yes'
    // }
    if (dom.parents('form').find('[name="properties[_gift_ecobag]"]').length) {
        if (!data.properties) {
            data.properties = {}
        }
        data.properties['_gift_ecobag'] = 'yes'
    }
    if (dom.parents('form').find('[name="properties[_gift_beret]"]').length) {
        if (!data.properties) {
            data.properties = {}
        }
        data.properties['_gift_beret'] = 'yes'
    }
    var params = {
        type: 'POST',
        url: Shopify.routes.root + 'cart/add.js',
        data: data,
        dataType: 'json',
        success: function(line_item) {
            window.pintrk && pintrk('track', 'addtocart', {
                event_id: 'eventId0001',
                value: line_item.price/100,
                order_quantity:line_item.quantity,
                currency:window.currencyCode,
                line_items: [
                    {
                        product_name: line_item.product_title,
                        product_id: line_item.sku,
                        product_category: line_item.product_type,
                    }
                ]
            });
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            // console.log(XMLHttpRequest)
            var message = window.cartStrings.addProductOutQuantity2;
            if (input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            }

            Shopify.onError(XMLHttpRequest, textStatus, message);
            target && target.classList.remove('is-loading');
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (data && !!data.message) {
        // if (window.innerWidth >= 767) {
        //     showWarning(data.message + '(' + data.status  + '): ' + data.description, warningTime);
        // } else {
            showWarning(data.message + ': ' + message, warningTime);
        // }
    } else {
        // if (window.innerWidth >= 767) {
        //     showWarning('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.', warningTime);
        // } else {
            showWarning('Error : ' + message, warningTime);
        // }
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = el_input.dataset.inventoryQuantity;
        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal < 0 ) {
            var newVal = 1
        }

        if (newVal > inStockNumber) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            var newVal = inStockNumber
        }

        el_input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = el_input.dataset.inventoryQuantity;

        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal < 0 ) {
            var newVal = 1
        }

        if (newVal > inStockNumber) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            var newVal = inStockNumber
        }

        el_input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
})



// predictive-search.js
class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.trendingAndProductsBlock = this.querySelector('[data-quick-trending-products]');
      this.closeStickySearchButton = document.querySelector('.header-search-close');
      this.productToShow = this.dataset.productToShow;
      this.searchDetails = this.querySelector('details.search_details')
      this.isOpen = false;

      this.setupEventListeners();
    }

    setupEventListeners() {
      const form = this.querySelector('form.search');
      form && form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input && this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 500).bind(this));
      this.input && this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      document.addEventListener('click', this.onDocClick.bind(this));
      this.closeStickySearchButton && this.closeStickySearchButton.addEventListener('click', this.onCloseStickySearchClick.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close(true);
        return;
      }

      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) return this.showTrendingAndProducts();

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.close();
          this.hideTrendingAndProducts();
        };
      })
    }

    onKeyup(event) {
      if (!this.getQuery().length) {
        this.close(true);
        this.showTrendingAndProducts();
      };
      event.preventDefault();

      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up')
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }

    onKeydown(event) {
      // Prevent the cursor from moving in the input when using the up and down arrow keys
      if (
        event.code === 'ArrowUp' ||
        event.code === 'ArrowDown'
      ) {
        event.preventDefault();
      }
    }

    switchOption(direction) {
      if (!this.getAttribute('open')) return;

      const moveUp = direction === 'up';
      const selectedElement = this.querySelector('[aria-selected="true"]');
      const allElements = this.querySelectorAll('li');
      let activeElement = this.querySelector('li');

      if (moveUp && !selectedElement) return;

      this.statusElement.textContent = '';

      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;

      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);

      this.setLiveRegionText(activeElement.textContent);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
      const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

      if (selectedProduct) selectedProduct.click();
    }

    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        this.updateViewAllLink(searchTerm);
        return;
      }

      // console.log(this.updateViewAllLink(searchTerm))

      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=${this.productToShow}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
          this.updateViewAllLink(searchTerm);
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;

      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.setAttribute('results', true);

      this.setLiveRegionResults();
      this.open();
      this.hideTrendingAndProducts();
    }

    setLiveRegionResults() {
      this.removeAttribute('loading');
      this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
      this.resultsMaxHeight = window.innerHeight - document.querySelector('[id^="shopify-section-header"]').getBoundingClientRect().bottom;
      return this.resultsMaxHeight;
    }

    open() {
      this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      this.searchDetails.setAttribute('open', true);
    }

    close(clearSearchTerm = false) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }

      const selected = this.querySelector('[aria-selected="true"]');

      if (selected) selected.setAttribute('aria-selected', false);

      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false
      this.predictiveSearchResults.removeAttribute('style');

      this.isOpen = false;
      this.searchDetails.removeAttribute('open', true);
    }

    showTrendingAndProducts() {
      if (!this.trendingAndProductsBlock) return
      this.trendingAndProductsBlock.classList.add('is-show')
      this.trendingAndProductsBlock.classList.remove('hidden')
    }

    hideTrendingAndProducts() {
      if (!this.trendingAndProductsBlock) return

      this.trendingAndProductsBlock.classList.remove('is-show')
      this.trendingAndProductsBlock.classList.add('hidden')
    }

    onDocClick(e) {
      let closeButton;
      if (e.target.matches('.header-search-popup-close') || e.target.matches('.header-search-close')) {
        closeButton = e.target
      } else if (e.target.closest('.header-search-popup-close')) {
        closeButton = e.target.closest('.header-search-popup-close')
      } else if (e.target.closest('.header-search-close')) {
        closeButton = e.target.closest('.header-search-close')
      }

      const isInModal = this.contains(e.target)

      if (isInModal && !closeButton) return;

      this.close();
      this.hideTrendingAndProducts();
    }

    onCloseStickySearchClick() {
      this.close();
      this.hideTrendingAndProducts();
      document.querySelector('body').classList.remove('sticky-search-open')
    }

    updateViewAllLink(searchTerm) {
      const qsViewAllLink = document.querySelector('[data-qs-view-all-link]');
      if (!qsViewAllLink) return

      const linkTotal = `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product`

      qsViewAllLink.href = linkTotal
      return this.getTotalResults(linkTotal).then(count => {
        qsViewAllLink.innerHTML = qsViewAllLink.innerHTML.replace('()', `(${count})`)
      });
    }

    getTotalResults(url) {
      return fetch(url)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const totalCount = new DOMParser().parseFromString(text, 'text/html').querySelector('[id^="SearchSection"]').dataset.searchCount;
          return totalCount
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  }

  customElements.define('predictive-search', PredictiveSearch);


// slider.js
class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('ul');
        this.sliderItems = this.querySelectorAll('li');
        this.pageCount = this.querySelector('.slider-counter--current');
        this.pageTotal = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.dotButton = this.querySelectorAll('button[name="dots"]');
        this.rtl_num = document.body.classList.contains('layout_rtl') ? -1 : 1;
        if (this.nextButton) {
            this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
            this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        }
        

        if (!this.slider) return;

        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);
        this.slider.addEventListener('scroll', this.update.bind(this));
        this.dotButton.forEach((button) => {
            button.addEventListener('click', this.onDotClick.bind(this));
        });

    }

    initPages() {
        if (!this.sliderItems.length === 0) return;
        this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
        this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    }

    update() {
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth * this.rtl_num);
        this.querySelector('.dots-item.active') && this.querySelector('.dots-item.active').classList.remove('active');
        this.querySelectorAll('.dots-item')[this.currentPage] && this.querySelectorAll('.dots-item')[this.currentPage].classList.add('active');
    }

    onButtonClick(event) {
        event.preventDefault();
        const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth * this.rtl_num : this.slider.scrollLeft - this.sliderItems[0].clientWidth * this.rtl_num;
        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }

    onDotClick(event) {
        event.preventDefault();
        this.dotActive = this.querySelector('.dots-item.active button');
        const sliderItemActive = this.dotActive.dataset.index;
        const sliderItem = event.currentTarget.dataset.index;
        const sliderCount = sliderItem > sliderItemActive ? sliderItem - sliderItemActive : sliderItemActive - sliderItem;
        this.querySelector('.dots-item.active').classList.remove('active');
        event.currentTarget.closest('.dots-item').classList.add('active');

        const slideScrollPosition = sliderItem * this.sliderItems[0].clientWidth;

        this.slider.scrollTo({
            left: slideScrollPosition
        });
    }



    // updateButtonDisable() {
    //     this.prevButton.classList.remove('disabled');
    //     this.nextButton.classList.remove('disabled');

    //     console.log(this.currentPage + 1, this.pagesToSlide)

    //     if (this.currentPage <= 0) {
    //         this.prevButton.classList.add('disabled')
    //     }

    //     if (this.currentPage + 1 >= this.totalPages) {
    //         this.nextButton.classList.add('disabled')
    //     }
    // }
}

customElements.define('slider-component', SliderComponent);

class ProductSliderComponent extends SliderComponent {
    constructor() {
        super();
        this.slider = this.querySelector('.slider');
        this.sliderItems = this.querySelectorAll('.slider__slide');
        this.pageCount = this.querySelector('.slider-counter--current');
        this.pageTotal = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.rtl_num = document.body.classList.contains('layout_rtl') ? -1 : 1;

        if (!this.slider || !this.nextButton) return;

        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        // 创建 MutationObserver 实例
        const observer = new MutationObserver(() => {
        this.slider = this.querySelector('.slider');
        this.sliderItems = this.querySelectorAll('.slider__slide');

        if (this.slider) {
            this.slider.addEventListener('scroll', this.update.bind(this));
        }

        if (this.prevButton) {
            this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        }

        if (this.nextButton) {
            this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        }

        if (this.dotButton) {
            this.dotButton.forEach((button) => {
            button.addEventListener('click', this.onDotClick.bind(this));
            });
        }
        });

        // 开始监听
        observer.observe(this, {
        childList: true, // 监听直接子节点变化
        subtree: true    // 监听所有后代节点
        });


        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton && this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton && this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        this.dotButton && this.dotButton.forEach((button) => {
            button.addEventListener('click', this.onDotClick.bind(this));
        });
    }
}

customElements.define('product-slider-component', ProductSliderComponent);

class BannerSliderComponent extends SliderComponent {
    constructor() {
        super();
        this.slider = this.querySelector('.slider');
        this.sliderItems = this.querySelectorAll('.slider__slide');

        if (!this.slider || !this.dotButton) return;

        const resizeObserver = new ResizeObserver(entries => this.initPages());
        resizeObserver.observe(this.slider);

        // 用 MutationObserver 监听 DOM 变化
        const observer = new MutationObserver(() => {
            this.slider = this.querySelector('.slider');
            this.sliderItems = this.querySelectorAll('.slider__slide');

            if (this.slider) {
                this.slider.addEventListener('scroll', this.update.bind(this));
            }

            if (this.prevButton) {
                this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
            }

            if (this.nextButton) {
                this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
            }

            if (this.dotButton && this.dotButton.length) {
                this.dotButton.forEach((button) => {
                    button.addEventListener('click', this.onDotClick.bind(this));
                });
            }
        });

        // 开始监听 this 元素的 DOM 变化
        observer.observe(this, {
            childList: true, // 监听子节点变化
            subtree: true    // 包括所有后代
        });


        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton && this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton && this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        this.dotButton.forEach((button) => {
            button.addEventListener('click', this.onDotClick.bind(this));
        });
        this.initButtonDisable();
    }

    initButtonDisable() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.target.classList.contains('first-item')) {
                        this.prevButton && this.prevButton.classList.add('disabled')
                    } else if (entry.target.classList.contains('last-item')) {
                        this.nextButton && this.nextButton.classList.add('disabled')
                    }
                } else {
                    if (entry.target.classList.contains('first-item')) {
                        this.prevButton && this.prevButton.classList.remove('disabled')
                    } else if (entry.target.classList.contains('last-item')) {
                        this.nextButton && this.nextButton.classList.remove('disabled')
                    }
                }
            })
        }, {
            threshold: 0.8,
            root: this.slider
        })

        this.sliderItems[0].classList.add('first-item')
        this.sliderItems[this.sliderItems.length - 1].classList.add('last-item')

        observer.observe(this.sliderItems[0])
        observer.observe(this.sliderItems[this.sliderItems.length - 1])
    }
}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('banner-slider-component', BannerSliderComponent);
})

// variants-edit-cart.js
class VariantEditCartSelects extends HTMLElement {
    constructor() {
        super();
        this.variantSelect = this;
        this.item = $(this.variantSelect).closest('.product-edit-item');

        if(this.variantSelect.classList.contains('has-default')){
            this.updateOptions();
            this.updateMasterId();
            this.renderProductInfo();
        }

        if (!this.currentVariant) {
            this.item[0].dataset.inStock = 'false'
        } else {
            if(this.item[0]) {
              this.item[0].dataset.inStock = this.currentVariant.available ? 'true': 'false'
            }
        }

        var inventory = this.currentVariant && this.currentVariant.inventory_management;

        if(inventory != null) {
            var productId = this.item.data('cart-edit-id'),
                arrayInVarName = 'edit_cart_inven_array_' + productId,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);
            }
        }

        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();

        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateMedia();
            this.updateVariantInput();
            this.updatePrice();
            this.renderProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
        }

        this.updateAddToCartButton();

        if (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) {
            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        let temp = this.currentVariant && this.currentVariant.featured_image
        if (!this.currentVariant || !temp) return;
        const itemImage = this.item.find('.product-edit-image');
        const image = temp;

        if (!itemImage) return;

        itemImage.find('img').attr({
            'src': image.src,
            'srcset': image.src,
            'alt': image.alt
        });
    }

    updateVariantInput() {
        const productForm = document.querySelector(`#product-form-edit-${this.dataset.product}`);

        if (!productForm) return;

        const input = productForm.querySelector('input[name="id"]');

        if (!input) return;

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updatePrice(){
        const itemPrice = this.item.find('.product-edit-price');
        if (!itemPrice || this.item.hasClass('product-edit-gift')) return;

        var price = this.currentVariant && this.currentVariant.price,
            compare_at_price = this.currentVariant && this.currentVariant.compare_at_price;

        itemPrice.find('.price').html(Shopify.formatMoney(price, window.money_format)).show();

        if(compare_at_price > price) {
            itemPrice.find('.compare-price').html(Shopify.formatMoney(compare_at_price, window.money_format)).show();
            itemPrice.find('.price').addClass('new-price');
        } else {
            itemPrice.find('.compare-price').hide();
            itemPrice.find('.price').removeClass('new-price');
        }
    }

    renderProductInfo() {
        var variantList = this.getVariantData().filter((variant) => {
            return variant.available
        });

        var selectedOption1 = this.currentVariant && this.currentVariant.option1,
            selectedOption2 = this.currentVariant && this.currentVariant.option2,
            selectedOption3 = this.currentVariant && this.currentVariant.option3,
            selectedVariant = this.currentVariant.title,
            options = this.getElementsByClassName('product-form__input');

        this.item.find('[data-change-title]').text(selectedVariant);

        $.each(options, (index, element) => {
            var position = $(element).data('option-index'),
                type = $(element).data('product-attribute');

            switch (position) {
                case 0:
                    $(element).find('[data-header-option]').text(selectedOption1);

                    if(type == 'set-select') {
                        var selectValue = $(element).find('.select__select').val(),
                            selectList = $(element).find('.select__select option');

                        selectList.each((idx, elt) => {
                            if(elt.value == selectValue){
                                $(elt).attr('selected', 'selected');
                            } else {
                                $(elt).removeAttr('selected');
                            }
                        });
                    }

                    var option1List = variantList.filter((variant) => {
                        return variant.option1 === selectedOption1;
                    });

                    if(selectedOption2){
                        var inputList = $(options[1]),
                            input = inputList.find('.product-form__radio'),
                            selectOption = inputList.find('.select__select option');

                        if(type == 'set-rectangle'){
                            input.each((idx, elt) => {
                                var $input = $(elt),
                                    $label = $input.next(),
                                    optionValue = $(elt).val();

                                var optionSoldout = option1List.find((variant) => {
                                    return variant.option2 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $label.removeClass('available').addClass('soldout');
                                } else {
                                    $label.removeClass('soldout').addClass('available');
                                }
                            });
                        } else {
                            selectOption.each((idx, elt) => {
                                var $option = $(elt),
                                    optionValue = $(elt).val();

                                var optionSoldout = option1List.find((variant) => {
                                    return variant.option2 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $option.attr('disabled', true);
                                } else {
                                    $option.removeAttr('disabled');
                                }
                            });
                        }
                    }

                    if(selectedOption3){
                        var inputList = $(options[2]),
                            input = inputList.find('.product-form__radio'),
                            selectOption = inputList.find('.select__select option');

                        if(type == 'set-rectangle'){
                            input.each((idx, elt) => {
                                var $input = $(elt),
                                    $label = $input.next(),
                                    optionValue = $(elt).val();

                                var optionSoldout = option1List.find((variant) => {
                                    return variant.option3 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $label.removeClass('available').addClass('soldout');
                                } else {
                                    $label.removeClass('soldout').addClass('available');
                                }
                            });
                        } else {
                            electOption.each((idx, elt) => {
                                var $option = $(elt),
                                    optionValue = $(elt).val();

                                var optionSoldout = option1List.find((variant) => {
                                    return variant.option3 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $option.attr('disabled', true);
                                } else {
                                    $option.removeAttr('disabled');
                                }
                            });
                        }
                    }

                    break;
                case 1:
                    try {
                        var specialSizes = $(element).closest('.product-edit-options').attr('data-special-sizes');
                        if (this.currentVariant && specialSizes) {
                            var S = this
                            var sizes = JSON.parse(specialSizes);
                            if (this.currentVariant.sku && this.currentVariant.sku.indexOf(sizes.handle)) {

                                var hideSizesMap = {}; // 用对象存储需要隐藏的尺寸，减少 indexOf 查找次数
                                var matchedSpu = false; // 是否找到匹配的 spu

                                sizes.productUnits.forEach(function(dc) {
                                    if (S.currentVariant.sku.indexOf(dc.spu) > -1) {
                                        matchedSpu = true;
                                        dc.sizes.forEach(function(size) {
                                            hideSizesMap[size] = true; // 直接用对象存储，判断更快
                                        });
                                    }
                                });

                                // 遍历 radio 选项，一次性完成 `hidden` 处理 & 选择新尺寸
                                var newSelectedSize = null;

                                $(element).find('.product-form__radio').each(function () {
                                    var value = $(this).val();
                                    var $label = $(this).next();

                                    if (hideSizesMap[value]) {
                                        $label.addClass('hidden'); // 需要隐藏
                                    } else {
                                        $label.removeClass('hidden'); // 需要显示

                                        // 选择第一个可用尺寸
                                        if (!newSelectedSize && $label.hasClass('available')) {
                                            newSelectedSize = value;
                                        }
                                    }
                                });

                                // 如果当前选中的尺寸被隐藏，就自动选择新尺寸
                                if (matchedSpu && hideSizesMap[S.currentVariant.option2] && newSelectedSize) {
                                    $(element).find('.product-form__radio[value="' + newSelectedSize + '"]').click();
                                    selectedOption2 = newSelectedSize;
                                }
                                
                            }
                        }
                    } catch (err) {}
                    $(element).find('[data-header-option]').text(selectedOption2);

                    if(type == 'set-select') {
                        var selectValue = $(element).find('.select__select').val(),
                            selectList = $(element).find('.select__select option');

                        selectList.each((idx, elt) => {
                            if(elt.value == selectValue){
                                $(elt).attr('selected', 'selected');
                            } else {
                                $(elt).removeAttr('selected');
                            }
                        });
                    }

                    var option2List = variantList.filter((variant) => {
                        return variant.option2 === selectedOption2;
                    });

                    if(selectedOption1){
                        var inputList = $(options[0]),
                            input = inputList.find('.product-form__radio'),
                            selectOption = inputList.find('.select__select option');

                        if(type == 'set-rectangle'){
                            input.each((idx, elt) => {
                                var $input = $(elt),
                                    $label = $input.next(),
                                    optionValue = $(elt).val();

                                var optionSoldout = option2List.find((variant) => {
                                    return variant.option1 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $label.removeClass('available').addClass('soldout');
                                } else {
                                    $label.removeClass('soldout').addClass('available');
                                }
                            });
                        } else {
                            selectOption.each((idx, elt) => {
                                var $option = $(elt),
                                    optionValue = $(elt).val();

                                var optionSoldout = option2List.find((variant) => {
                                    return variant.option1 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $option.attr('disabled', true);
                                } else {
                                    $option.removeAttr('disabled');
                                }
                            });
                        }
                    }

                    if(selectedOption3){
                        var inputList = $(options[2]),
                            input = inputList.find('.product-form__radio'),
                            selectOption = inputList.find('.select__select option');

                        if(type == 'set-rectangle'){
                            input.each((idx, elt) => {
                                var $input = $(elt),
                                    $label = $input.next(),
                                    optionValue = $(elt).val();

                                var optionSoldout = option2List.find((variant) => {
                                    return variant.option3 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $label.removeClass('available').addClass('soldout');
                                } else {
                                    $label.removeClass('soldout').addClass('available');
                                }
                            });
                        } else {
                            electOption.each((idx, elt) => {
                                var $option = $(elt),
                                    optionValue = $(elt).val();

                                var optionSoldout = option2List.find((variant) => {
                                    return variant.option3 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $option.attr('disabled', true);
                                } else {
                                    $option.removeAttr('disabled');
                                }
                            });
                        }
                    }

                    break;
                case 2:
                    $(element).find('[data-header-option]').text(selectedOption3);

                    if(type == 'set-select') {
                        var selectValue = $(element).find('.select__select').val(),
                            selectList = $(element).find('.select__select option');

                        selectList.each((idx, elt) => {
                            if(elt.value == selectValue){
                                $(elt).attr('selected', 'selected');
                            } else {
                                $(elt).removeAttr('selected');
                            }
                        });
                    }

                    var option3List = variantList.filter((variant) => {
                        return variant.option3 === selectedOption3;
                    });

                    if(selectedOption1){
                        var inputList = $(options[0]),
                            input = inputList.find('.product-form__radio'),
                            selectOption = inputList.find('.select__select option');

                        if(type == 'set-rectangle'){
                            input.each((idx, elt) => {
                                var $input = $(elt),
                                    $label = $input.next(),
                                    optionValue = $(elt).val();

                                var optionSoldout = option3List.find((variant) => {
                                    return variant.option1 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $label.removeClass('available').addClass('soldout');
                                } else {
                                    $label.removeClass('soldout').addClass('available');
                                }
                            });
                        } else {
                            selectOption.each((idx, elt) => {
                                var $option = $(elt),
                                    optionValue = $(elt).val();

                                var optionSoldout = option3List.find((variant) => {
                                    return variant.option1 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $option.attr('disabled', true);
                                } else {
                                    $option.removeAttr('disabled');
                                }
                            });
                        }
                    }

                    if(selectedOption2){
                        var inputList = $(options[1]),
                            input = inputList.find('.product-form__radio');

                        if(type == 'set-rectangle'){
                            input.each((idx, elt) => {
                                var $input = $(elt),
                                    $label = $input.next(),
                                    optionValue = $(elt).val();

                                var optionSoldout = option3List.find((variant) => {
                                    return variant.option2 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $label.removeClass('available').addClass('soldout');
                                } else {
                                    $label.removeClass('soldout').addClass('available');
                                }
                            });
                        } else {
                            selectOption.each((idx, elt) => {
                                var $option = $(elt),
                                    optionValue = $(elt).val();

                                var optionSoldout = option3List.find((variant) => {
                                    return variant.option2 == optionValue
                                });

                                if(optionSoldout == undefined){
                                    $option.attr('disabled', true);
                                } else {
                                    $option.removeAttr('disabled');
                                }
                            });
                        }
                    }

                    break;
            }
        });

        var inventory = this.currentVariant && this.currentVariant.inventory_management;

        if(inventory != null) {
            var productId = this.item.data('cart-edit-id'),
                arrayInVarName = 'edit_cart_inven_array_' + productId,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if(this.item.find('.product-edit-hotStock').length > 0){
                    var hotStock = this.item.find('.product-edit-hotStock'),
                        maxStock = hotStock.data('edit-cart-hot-stock');

                    if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
                        var textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
                        hotStock.text(textStock).show();
                    } else {
                        hotStock.hide();
                    }
                }
            }
        }
    }

    updateAttribute(unavailable = true, disable = true){
        if (this.currentVariant && this.currentVariant.compare_at_price) {
            var isFlash = this.item.find('.product-edit-itemRight').attr('data-flash') == 'true';
            if (this.currentVariant.compare_at_price == this.currentVariant.price) {
                this.item.find('[name="properties[_is_final_sale]"]').remove();
            } else {
                if (!this.item.find('[name="properties[_is_final_sale]"]').length && !this.item.find('[name="properties[_is_final_sale_bgf]"]').length) {
                    this.item.find('[name="product-id"]').before('<input type="hidden" name="properties[_is_final_sale]" value="yes">')
                }
            }
        }
        var alertBox = this.item.find('.alertBox'),
            quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.product-edit-notifyMe'),
            hotStock = this.item.find('.productView-hotStock');

        if(unavailable){
            this.item.removeClass('isChecked');
            quantityInput.attr('disabled', true);
            alertBox.find('.alertBox-message').text(window.variantStrings.unavailable_message);
            alertBox.show();
            notifyMe.slideUp('slow');

            if(hotStock.length > 0){
                hotStock.hide();
            }
        } else {
            if (disable) {
                this.item.removeClass('isChecked');
                quantityInput.attr('disabled', true);
                alertBox.find('.alertBox-message').text(window.variantStrings.soldOut_message);
                alertBox.show();

                this.item.find('.quantity__message').empty().hide();

                if(notifyMe.length > 0){
                    notifyMe.find('input[name="halo-notify-product-variant"]').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else{
                this.item.addClass('isChecked')
                quantityInput.attr('disabled', false);
                alertBox.find('.alertBox-message').text('');
                alertBox.hide();

                if(notifyMe.length > 0){
                    notifyMe.slideUp('slow');
                }
            }
        }

        if (this.item[0]) {
          this.item[0].dataset.inStock = this.currentVariant.available ? 'true' : 'false';
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    updateAddToCartButton() {
        const editCartWrapper = this.variantSelect.closest('[data-template-cart-edit]');
        if (!editCartWrapper) return
        const productItems = [...editCartWrapper.querySelectorAll('.product-edit-item')];
        const updateEditCartButton = this.variantSelect.closest('[data-edit-cart-popup]').querySelector('[data-update-cart-edit]');
        const allValid = productItems.every(productItem => productItem.dataset.inStock == 'true');

        if (allValid) {
            updateEditCartButton.disabled = false
        } else {
            updateEditCartButton.disabled = true
        }
    }
}

customElements.define('variant-edit-selects', VariantEditCartSelects);

class VariantEditCartRadios extends VariantEditCartSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            var values = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            return values ? values.value : null;
        });
    }
}

customElements.define('variant-edit-radios', VariantEditCartRadios);

class QuantityEditCartInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.item = $(this.input).closest('.product-edit-item');
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        const value = Number(this.input.value);
        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if(inputValue < 1) {
            newVal = 1;
            this.input.value =  newVal;
        }

        var currentId = '';
        var _dom = document.getElementById(`product-form-edit-${this.input.dataset.product}`);
        if (_dom && _dom.querySelector('[name="id"]')) {
            currentId = _dom.querySelector('[name="id"]').value
        }

        if (newVal > maxValue) {
            var arrayInVarName = `cart_selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
            if(itemStatus == 'deny') {
                newVal = maxValue
                this.input.value =  newVal;
                const message = getInputMessage(maxValue);
                showWarning(message, 3000);
            }
        }

        this.input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);
    }

    onInputChange(event) {
        event.preventDefault();
        var inputValue = Number(this.input.value);
        var inventoryQuantity = Number(this.input.dataset.quantity);

        if(inputValue < 1) {
            inputValue = 1;
            this.input.value =  inputValue;
        } else {
            if (inventoryQuantity < inputValue) {
                var message = window.inventory_text.warningQuantity.replace('[inventory]', inventoryQuantity);

                inputValue = inventoryQuantity;
                this.input.value =  inputValue;

                this.item.find('.quantity__message').text(message).show();
                this.item.removeClass('isChecked');
            } else {
                this.item.addClass('isChecked');
                this.item.find('.quantity__message').empty().hide();
            }
        }
    }
}

customElements.define('quantity-edit-cart-input', QuantityEditCartInput);


// variants-quick-view.js
class VariantQuickViewSelects extends HTMLElement {
    constructor() {
        super();
        this.item = this.closest('.quickView');
        this.variants = this.getVariantData();

        this.onVariantInit = debounce(() => {
            this.updateOptions();
            this.updateMasterId();
            this.updateMedia(500);
            this.updateVariants(this.variants);
            if (this.checkNeedToConvertCurrency()) {
                var _dom = document.getElementById('currencies');
                let currencyCode = '';
                if (_dom && _dom.querySelector('.active')) {
                    currencyCode = currencyCode = _dom.querySelector('.active').getAttribute('data-currency');
                }

                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }
        }, 500);

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
        // 更新轮播图
        const that = this;
        $(function() {
            setTimeout(() => {
                that.updateCarousel();
                var $variantRadios = $('variant-quick-view-radios');
                var $colorRadios = $variantRadios.find('.product-form__radio[name="color"]');

                if ($colorRadios.length > 1) {
                    try {
                        var $checked = $variantRadios.find('.product-form__swatch .product-form__radio:checked');
                        var colorValue = $checked.val();

                        var variantsJson = $variantRadios.find('[type="application/json"]').html();
                        if (variantsJson) {
                            var variants = JSON.parse(variantsJson);
                            var needToSwitchColor = customGlobal.checkStockStatusByOption(variants, colorValue);

                            if (needToSwitchColor.meetsRule) {
                                var targetColor = customGlobal.findFirstQualifiedColor(variants);
                                if (targetColor && targetColor.option1) {
                                    var $targetRadio = $variantRadios.find('.product-form__swatch .product-form__radio[value="' + targetColor.option1 + '"]');
                                    if ($targetRadio.length) {
                                        $targetRadio.click();
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.warn('Variant color switch error:', e);
                    }
                }
            })
        });
    }

    updateCarousel() {
        if (!window.halo) return
        const $productGallery = $('.halo-quickView .halo-quickView-left.productView-images')
        const skcMediaInfo = $productGallery.data('quick-skc-media-info')

        if (!skcMediaInfo) return
        var colorValue = $('variant-quick-view-radios').find('.product-form__swatch .product-form__radio:checked').val();
        const mediaData = skcMediaInfo.find(item => item.standardColor == colorValue)
        if (!mediaData || $('variant-quick-view-radios').find('.product-form__radio[name="color"]').length <= 1) {
            this.updateMedia(200);
            return
        }
        const mediaList = mediaData.image
        if (mediaData.video) {
            mediaList.splice(1, 0, mediaData.video)
        }
        const $productGalleryList = $productGallery.find('.productView-nav')
        $productGalleryList.removeClass('slick-initialized slick-slider')
        const featuredImg = $('.halo-quickView-right .product-form__radio:checked[name="color"]').next('.product-form__label').find('.pattern').data('image')
        const videoCover = mediaData.image.find(i => i.includes(featuredImg))
        $productGalleryList.html(mediaList.map((item,index) => {
            if (index === 1 && mediaData.video) {
                return `
                    <div class="productView-image productView-image-portrait">
                        <div class="productView-img-container product-single__media" style="padding-bottom:133.3%;">
                            <div class="media has-video">
                                <img
                                    srcset="${videoCover}"
                                    src="${videoCover}"
                                    sizes="(min-width: 1200px) calc((1200px - 10rem) / 2), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
                                    loading="lazy"
                                    data-sizes="auto"
                                >
                            </div>
                            <div class="productView-video mp4" data-mp4="" data-type="mp4">
                                <video playsinline="playsinline" controls="controls" preload="metadata"  poster="${videoCover}"><source src="${mediaData.video}" type="video/mp4"><img src="${videoCover}"></video>
                            </div>
                        </div>
                    </div>
                `
            }
            return `
                <div class="productView-image productView-image-portrait fit-unset" data-index="${index > 1 && mediaData.video ? index + 1 : index}">
                    <div class="productView-img-container product-single__media" ${item.includes(featuredImg) ? 'data-media-initial' : ''}>
                        <div class="media" data-fancybox="images" href="${item}">
                            <img srcset="${item}"
                                src="${item}"
                                loading="lazy"
                                class="lazyloading"
                                data-sizes="auto"
                                data-main-image
                                data-index="${index > 1 && mediaData.video ? index + 1 : index}"
                                data-cursor-image
                            />
                        </div>
                    </div>
                </div>
            `
        }).join(''))
        const $productGalleryThumb = $productGallery.find('.productView-for')
        $productGalleryThumb.removeClass('slick-initialized slick-slider')
        $productGalleryThumb.html(mediaList.map((item,index) => {
            if (index === 1 && mediaData.video) {
                return `
                    <div class="productView-thumbnail __video"">
                        <div class="productView-thumbnail-link animated-loading">
                            <img src="${videoCover}" loading="lazy" />
                        </div>
                        <div class="productView-thumbnail-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" aria-hidden="true" focusable="false" role="presentation" class="icon icon-video">
                                <path fill="none" d="M256,20C125.872,20,20,125.872,20,256s105.872,236,236,236s236-105.872,236-236S386.128,20,256,20z   M156.64,387.712V124.288l246.72,131.72L156.64,387.712z"></path>
                                <path d="M512,256C512,114.616,397.384,0,256,0S0,114.616,0,256s114.616,256,256,256S512,397.384,512,256z   M256,492C125.872,492,20,386.128,20,256S125.872,20,256,20s236,105.872,236,236S386.128,492,256,492z"></path>
                                <polygon points="156.64,387.712 403.36,256.008 156.64,124.288 "></polygon>
                            </svg>
                        </div>
                    </div>
                `
            }
            return `
                <div class="productView-thumbnail" ${item.includes(featuredImg) ? 'data-media-initial' : ''}>
                    <a class="productView-thumbnail-link animated-loading" href="javascript:void(0)"
                        data-image="${item}">
                        <img data-srcset="${item}" loading="lazy" class="lazyloading"
                            srcset="${item}">
                    </a>
                </div>
            `
        }).join(''))
        halo.productImageGallery($('.quickView'))
        setTimeout(() => {
            this.updateMedia(200, 'data-media-initial');
        })
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariants(this.variants);
        if ($(event.target).parents('.product-form__input').hasClass('error')) {
            $(event.target).parents('.product-form__input').removeClass('error');
        }
        if (!this.currentVariant) {
            var value = $(event.target).val();
            this.updateAttribute(true, true, this.getVariantData().filter(acc => acc.option1 == value)[0]);
            // 更新轮播图
            if ($(event.target).closest('.product-form__swatch').length) {
                this.updateCarousel()
            }
            var defaultId = this.getVariantData().filter(acc => acc.option1 == value)[0]?.id;
            this.updateProductInfo(defaultId);
        } else {
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
            // 更新轮播图
            if ($(event.target).closest('.product-form__swatch').length) {
                this.updateCarousel()
            }
        }
    }

    updateVariants(variants){
        const options = Array.from(this.querySelectorAll('.product-form__input'));
        var _dom = document.getElementById(`product-quick-view-option-${this.dataset.product}`);
        const type = _dom && _dom.getAttribute('data-type');
        var isSelectSize = $(this.item).find('.product-form__input:not(.product-form__swatch):not(.product-form__color) input:checked');

        let selectedOption1;
        let selectedOption2;
        let selectedOption3;

        if (variants) {
            if (type == 'button') {
                // console.log(options[0].querySelector('[data-header-option]'));
                if (options[0] && Array.from(options[0].querySelectorAll('input')).find((radio) => radio.checked)) {
                    selectedOption1 = Array.from(options[0].querySelectorAll('input')).find((radio) => radio.checked).value;
                    options[0].querySelector('[data-header-option]').textContent = selectedOption1;
                }

                if (options[1]) {
                    var sizeChecked = Array.from(options[1].querySelectorAll('input')).find((radio) => radio.checked);
                    $(sizeChecked).length && (selectedOption2 = $(sizeChecked).val());
                    try {
                        var specialSizes = $(options[1]).closest('.productView-options').attr('data-special-sizes');
                        if (specialSizes) {
                            var S = this
                            var sizes = JSON.parse(specialSizes);
                            var sku =  $('variant-quick-view-radios .product-form__swatch').find('input:checked') ?  $('variant-quick-view-radios .product-form__swatch').find('input:checked').attr('data-sku') : $('[data-sku] .productView-info-value').html();
                            if (sku.indexOf(sizes.handle) > -1 || sizes.handle == 'goelia-gift-box') {
                                var hideSizesMap = {}; // 用对象存储需要隐藏的尺寸，减少 indexOf 查找次数
                                var matchedSpu = false; // 是否找到匹配的 spu
                                sizes.productUnits.forEach(function(dc) {
                                    if (sku.indexOf(dc.spu) > -1) {
                                        matchedSpu = true;
                                        dc.sizes.forEach(function(size) {
                                            hideSizesMap[size] = true; // 直接用对象存储，判断更快
                                        });
                                    }
                                });

                                // 遍历 radio 选项，一次性完成 `hidden` 处理 & 选择新尺寸
                                var newSelectedSize = null;

                                $(options[1]).find('.product-form__radio').each(function () {
                                    var value = $(this).val();
                                    var $label = $(this).next();

                                    if (hideSizesMap[value]) {
                                        $label.addClass('hidden'); // 需要隐藏
                                    } else {
                                        $label.removeClass('hidden'); // 需要显示

                                        // 选择第一个可用尺寸
                                        if (!newSelectedSize && $label.hasClass('available')) {
                                            newSelectedSize = value;
                                        }
                                    }
                                });

                                var variantList = variants.filter(acc => acc.option1 == selectedOption1 && acc.option2 == newSelectedSize);
                                if (variantList.length && !variantList[0].available) {
                                    var variantListNew = variants.filter(acc => acc.option1 == selectedOption1 && acc.available);
                                    if (variantListNew.length) {
                                        newSelectedSize = variantListNew[0].option2;
                                    }
                                }

                                if (!variantList.length) {
                                    var variantListNew2 = variants.filter(acc => acc.option1 == selectedOption1 && acc.available);
                                    variantListNew2.length && (newSelectedSize = variantListNew2[0].option2);
                                }

                                // 如果当前选中的尺寸被隐藏，就自动选择新尺寸
                                if (S.currentVariant && matchedSpu && hideSizesMap[S.currentVariant.option2] && newSelectedSize) {
                                    $(options[1]).find('.product-form__radio[value="' + newSelectedSize + '"]').click();
                                    selectedOption2 = newSelectedSize;
                                }
                            }
                        }
                    } catch (err) {}
                    options[1].querySelector('[data-header-option]').textContent = selectedOption2;
                }

                if (options[2] && Array.from(options[2].querySelectorAll('input')).find((radio) => radio.checked)) {
                    selectedOption3 = Array.from(options[2].querySelectorAll('input')).find((radio) => radio.checked).value;
                    options[2].querySelector('[data-header-option]').textContent = selectedOption3;
                }

                var checkVariant = () => {
                    var optionsSize = parseInt(options.length);

                    if(optionsSize > 1){
                        var variantList = variants.filter((variant) => {
                            switch (optionsSize) {
                                case 2: return variant.option2 === selectedOption2;
                                case 3: return variant.option3 === selectedOption3;
                            }
                        });
                        if (!variantList.length) {
                            variantList = variants[0];
                        }

                        var input1List = options[0].querySelectorAll('.product-form__radio');
                        var isBundles = $('variant-quick-view-radios').hasClass('product-option-bundles');
                        isSelectSize.length && !isBundles && input1List.forEach((input) => {
                            var label = input.nextSibling;
                            var optionSoldout = Array.from(variantList).find((variant) => {
                                return variant.option1 == input.value && variant.available;
                            });

                            var optionUnavailable = Array.from(variantList).find((variant) => {
                                return variant.option1 == input.value;
                            });

                            if(optionSoldout == undefined){
                                if (optionUnavailable == undefined) {
                                    label.classList.remove('available');
                                    label.classList.remove('soldout');
                                    label.classList.add('unavailable');
                                } else {
                                    label.classList.remove('available');
                                    label.classList.remove('unavailable');
                                    label.classList.add('soldout');
                                }
                            } else {
                                label.classList.remove('soldout');
                                label.classList.remove('unavailable');
                                label.classList.add('available');
                            }
                        });
                    }
                };

                var updateVariant = (optionSoldout, optionUnavailable, element, optionIndex) => {
                    var label = element.nextSibling;

                    if(optionSoldout == undefined){
                        if (optionUnavailable == undefined) {
                            label.classList.remove('available');
                            label.classList.remove('soldout');
                            label.classList.add('unavailable');
                        } else {
                            label.classList.remove('available');
                            label.classList.remove('unavailable');
                            label.classList.add('soldout');
                        }
                    } else {
                        label.classList.remove('soldout');
                        label.classList.remove('unavailable');
                        label.classList.add('available');
                    }
                };

                var renderVariant = (optionIndex, fieldset) => {
                    const inputList = fieldset.querySelectorAll('.product-form__radio');

                    inputList.forEach((input) => {
                        const inputVal = input.value;

                        const optionSoldout = variants.find((variant) => {
                            switch (optionIndex) {
                                case 0: return variant.option1 == inputVal && variant.available;
                                case 1: return variant.option1 == selectedOption1 && variant.option2 == inputVal && variant.available;
                                case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == inputVal && variant.available;
                            }
                        });

                        const optionUnavailable = variants.find((variant) => {
                            switch (optionIndex) {
                                case 0: return variant.option1 == inputVal;
                                case 1: return variant.option1 == selectedOption1 && variant.option2 == inputVal;
                                case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == inputVal;
                            }
                        });
                        var input1List = options[0].querySelectorAll('.product-form__radio');
                        var isBundles = $('variant-quick-view-radios').hasClass('product-option-bundles');
                        !isBundles && updateVariant(optionSoldout, optionUnavailable, input, optionIndex);
                    });
                };
            } else {
                if (options[0] && options[0].querySelector('select').length) {
                    selectedOption1 = options[0].querySelector('select').value;
                    options[0].querySelector('[data-header-option]').textContent = selectedOption1;
                }

                if (options[1] && options[1].querySelector('select').length) {
                    selectedOption2 = options[1].querySelector('select').value;
                    options[1].querySelector('[data-header-option]').textContent = selectedOption2;
                }

                if (options[2] && options[2].querySelector('select').length) {
                    selectedOption3 = options[2].querySelector('select').value;
                    options[2].querySelector('[data-header-option]').textContent = selectedOption3;
                }

                var checkVariant = () => {
                    var optionsSize = parseInt(options.length);

                    if(optionsSize > 1){
                        var variantList = variants.filter((variant) => {
                            switch (optionsSize) {
                                case 2: return variant.option2 === selectedOption2;
                                case 3: return variant.option3 === selectedOption3;
                            }
                        });

                        var option1List = options[0].querySelectorAll('option');

                        option1List.forEach((option) => {
                            var optionSoldout = Array.from(variantList).find((variant) => {
                                return variant.option1 == option.value && variant.available;
                            });

                            var optionUnavailable = Array.from(variantList).find((variant) => {
                                return variant.option1 == option.value;
                            });

                            if(optionSoldout == undefined){
                                if (optionUnavailable == undefined) {
                                    option.classList.remove('available');
                                    option.classList.remove('soldout');
                                    option.classList.add('unavailable');
                                    option.setAttribute('disabled','disabled');
                                } else {
                                    option.classList.remove('available');
                                    option.classList.remove('unavailable');
                                    option.classList.add('soldout');
                                    option.removeAttribute('disabled');
                                }
                            } else {
                                option.classList.remove('soldout');
                                option.classList.remove('unavailable');
                                option.classList.add('available');
                                option.removeAttribute('disabled');
                            }
                        });
                    }
                };

                var updateVariant = (optionSoldout, optionUnavailable, element) => {
                    if(optionSoldout == undefined){
                        if (optionUnavailable == undefined) {
                            element.classList.remove('available');
                            element.classList.remove('soldout');
                            element.classList.add('unavailable');
                            element.setAttribute('disabled','disabled');
                        } else {
                            element.classList.remove('available');
                            element.classList.remove('unavailable');
                            element.classList.add('soldout');
                            element.removeAttribute('disabled');
                        }
                    } else {
                        element.classList.remove('soldout');
                        element.classList.remove('unavailable');
                        element.classList.add('available');
                        element.removeAttribute('disabled');
                    }
                };

                var renderVariant = (optionIndex, select) => {
                    const optionList = select.querySelectorAll('option');

                    optionList.forEach((option) => {
                        const optionVal = option.getAttribute('value');

                        const optionSoldout = variants.find((variant) => {
                            switch (optionIndex) {
                                case 0: return variant.option1 == optionVal && variant.available;
                                case 1: return variant.option1 == selectedOption1 && variant.option2 == optionVal && variant.available;
                                case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == optionVal && variant.available;
                            }
                        });

                        const optionUnavailable = variants.find((variant) => {
                            switch (optionIndex) {
                                case 0: return variant.option1 == optionVal;
                                case 1: return variant.option1 == selectedOption1 && variant.option2 == optionVal;
                                case 2: return variant.option1 == selectedOption1 && variant.option2 == selectedOption2 && variant.option3 == optionVal;
                            }
                        });

                        updateVariant(optionSoldout, optionUnavailable, option);
                    });
                };
            }

            options.forEach((fieldset) => {
                const optionIndex = parseInt(fieldset.getAttribute('data-option-index'));

                renderVariant(optionIndex, fieldset);
                checkVariant();
            });
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia(time, dataMediaInitial) {
        var _dom = this.currentVariant;
        if (!this.currentVariant || !(_dom && _dom.featured_media)) return;

        const newMedia = document.querySelectorAll(
            dataMediaInitial ? `[${dataMediaInitial}]` : `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
        );

        if (!newMedia) return;

        window.setTimeout(() => {
            $(newMedia).trigger('click');
        }, time);
    }

    updateProductInfo(id) {
        var variantId = id;
        if (this.currentVariant) {
            variantId = this.currentVariant.id;
        };
        if (!variantId) return;
        fetch(`${this.dataset.url}?variant=${variantId}&view=quick_view`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`product-quick-view-price-${this.dataset.product}`);
                const source = html.getElementById(id);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    var _dom = document.getElementById('currencies');
                    let currencyCode = '';
                    if (_dom && _dom.querySelector('.active')) {
                        currencyCode = _dom.querySelector('.active').getAttribute('data-currency');
                    }

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                destination && destination.classList.remove('visibility-hidden');

                if ($('[data-quick-view-popup] [data-init-flash-sale-mb]').length) {
                    window.currencyConverter && window.currencyConverter($('[data-quick-view-popup]'));
                }
        });
    }

    updateAttribute(unavailable = true, disable = true, objData){
        var currentVariant = objData || this.currentVariant;
        if (currentVariant && currentVariant.compare_at_price && !$('[data-quick-view-popup] [data-init-flash-sale-mb]').length) {
            var isFlash = $(this.item).find('.product-form__buttons').attr('data-flash') == 'true';
            var isFlashNew = $(this.item).find('.product-form__buttons').attr('data-flash-new') == 'true';
            if (currentVariant.compare_at_price == currentVariant.price) {
                $(this.item).find('.productView-badge.sale-true').hide();
                $(this.item).find('.productView-badge.sale-false').show();
                $(this.item).find('[name="properties[_is_final_sale]"]').remove();
            } else {
                $(this.item).find('.productView-badge.sale-false').hide();
                var minusprice = currentVariant.compare_at_price - currentVariant.price;
                var percentage = minusprice / currentVariant.compare_at_price * 100;
                var percNum = Math.round(percentage);
                if (!$(this.item).find('.productView-badge.sale-true').length) {
                    $(this.item).find('.productView-image-wrapper').prepend(`<div class="productView-badge badge-left halo-productBadges halo-productBadges--left date- date1- sale-true" data-new-badge-number=""><span class="badge sale-badge" aria-hidden="true">${percNum}% OFF</span></div>`);
                } else {
                    $(this.item).find('.productView-badge.sale-true').show().find('.badge').html(`${percNum}% OFF`);
                }
                if (!$(this.item).find('[name="properties[_is_final_sale]"]').length && !$(this.item).find('[name="properties[_is_final_sale_bgf]"]').length) {
                    $(this.item).find('.product-form__buttons').before('<input type="hidden" name="properties[_is_final_sale]" value="yes">')
                }
            }
        }
        this.quantityInput = this.item.querySelector('input[name="quantity"]');
        this.inventoryProp = this.item.querySelector('[data-inventory]');
        this.skuProp = this.item.querySelector('[data-sku]');
        this.notifyMe = this.item.querySelector('.productView-notifyMe');
        this.hotStock = this.item.querySelector('.productView-hotStock');
        var _dom = document.getElementById(`product-quick-view-form-${this.dataset.product}`);
        const addButton = _dom && _dom.querySelector('[name="add"]');
        const productForms = document.querySelectorAll(`#product-quick-view-form-${this.dataset.product}, #product-quick-view-form-installment-${this.dataset.product}`);

        let quantityInputValue = this.quantityInput && parseInt(this.quantityInput.value),
            quantityInputMaxValue,
            alertText = window.inventory_text.max,
            alertMessage = `<div class="alertBox alertBox--error"><p class="alertBox-message">${alertText}</p></div>`;
        var isSelectSize = $(this.item).find('.product-form__input:not(.product-form__swatch):not(.product-form__color) input:checked');
        var isBundles = $('variant-quick-view-radios').hasClass('product-option-bundles');
        if(unavailable && isSelectSize.length && !isBundles){
            let text = window.variantStrings.unavailable;
            this.quantityInput.setAttribute('disabled', true);

            if(this.notifyMe){
                this.notifyMe.style.display = 'none';
            }

            if(this.hotStock){
                this.hotStock.style.display = 'none';
            }

            addButton.setAttribute('disabled', true);
            addButton.textContent = text;
            this.quantityInput.closest('quantity-quick-view-input').classList.add('disabled');
        } else {
            if (disable && isSelectSize.length && !isBundles) {
                let text = window.variantStrings.soldOut;

                this.quantityInput.setAttribute('data-price', currentVariant && currentVariant.price);
                this.quantityInput.setAttribute('disabled', true);
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
                this.quantityInput.closest('quantity-quick-view-input').classList.add('disabled');

                if(this.inventoryProp){
                    this.inventoryProp.querySelector('.productView-info-value').textContent = window.inventory_text.outOfStock;
                }

                if(this.notifyMe){
                    this.notifyMe.querySelector('input[name="halo-notify-product-variant"]').value = currentVariant.title;
                    this.notifyMe.querySelector('.notifyMe-text').innerHTML = '';
                    this.notifyMe.style.display = 'block';
                }

                if(this.hotStock){
                    this.hotStock.style.display = 'none';
                }
            } else{
                let text,
                    inventory = currentVariant && currentVariant.inventory_management,
                    arrayInVarName,
                    inven_array,
                    inven_num,
                    inventoryQuantity;

                if(inventory != null) {
                    arrayInVarName = `quick_view_inven_array_${this.dataset.product}`;
                    inven_array = window[arrayInVarName];

                    if(inven_array != undefined) {
                        inven_num = inven_array[currentVariant.id];
                        inventoryQuantity = parseInt(inven_num);
                        // console.log(this.quantityInput)
                        if (typeof inventoryQuantity != 'undefined'){
                            if(inventoryQuantity > 0) {
                                this.quantityInput.setAttribute('data-inventory-quantity', inventoryQuantity);
                            } else {
                                this.quantityInput.removeAttribute('data-inventory-quantity');
                            }
                        } else {
                            this.quantityInput.setAttribute('data-inventory-quantity', inventoryQuantity);
                        }
                    }
                }

                if (typeof inventoryQuantity != 'undefined'){
                    if(inventoryQuantity > 0) {
                        text = window.variantStrings.addToCart;
                    } else  {
                        text = window.variantStrings.preOrder;
                    }
                } else{
                    text = window.variantStrings.addToCart;
                }

                if (currentVariant) {
                    this.quantityInput.setAttribute('data-price', currentVariant && currentVariant.price);
                }
                this.quantityInput.removeAttribute('disabled');

                addButton.innerHTML = text;
                addButton.removeAttribute('disabled');
                this.quantityInput.removeAttribute('disabled');
                this.quantityInput.closest('quantity-quick-view-input').classList.remove('disabled');

                if(window.quick_view_subtotal.show) {
                    let subTotal = 0;
                    let price = this.quantityInput.dataset.price

                    subTotal = quantityInputValue * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let _dom = document.getElementById('currencies');
                        let currencyCode = '';
                        if (_dom && _dom.querySelector('.active')) {
                            currencyCode = _dom.querySelector('.active').getAttribute('data-currency');
                        }
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()
                    const pdView_subTotal = document.querySelector('.quickView .productView-subtotal .money') || document.querySelector('.quickView .productView-subtotal .money-subtotal');
                    pdView_subTotal.innerText = subTotal;
                }

                if(inventoryQuantity > 0) {
                    addButton.classList.remove('button-text-pre-order');
                    quantityInputMaxValue = this.quantityInput && parseInt(this.quantityInput.getAttribute('data-inventory-quantity'));

                    if(this.inventoryProp != null){
                        if(inventoryQuantity > 0){
                            const showStock = this.inventoryProp.getAttribute('data-stock-level');
                            if (showStock == 'show') {
                                this.item.querySelector('[data-inventory] .productView-info-value').textContent = inventoryQuantity+' '+window.inventory_text.inStock;
                            }
                            else {
                                this.item.querySelector('[data-inventory] .productView-info-value').textContent = window.inventory_text.inStock;
                            }
                        } else {
                            this.item.querySelector('[data-inventory] .productView-info-value').textContent = window.inventory_text.outOfStock;
                        }
                    }

                    if(this.hotStock){
                        let maxStock = parseInt(this.hotStock.getAttribute('data-hot-stock'));

                        if(0 < inventoryQuantity && inventoryQuantity <= maxStock){
                            let textStock = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);

                            this.hotStock.innerHTML = textStock;
                            this.hotStock.style.display = 'block';
                        } else {
                            this.hotStock.innerHTML = '';
                            this.hotStock.style.display = 'none';
                        }
                    }
                } else{
                    addButton.removeAttribute('disabled');
                    addButton.classList.add('button-text-pre-order');

                    if(this.inventoryProp){
                        this.inventoryProp.querySelector('.productView-info-value').textContent = window.inventory_text.inStock;
                    }

                    if(this.hotStock){
                        this.hotStock.style.display = 'none';
                    }
                }

                if(this.notifyMe){
                    this.notifyMe.style.display = 'none';
                }

                if (this.checkNeedToConvertCurrency()) {
                    let _dom = document.getElementById('currencies');
                    let currencyCode = '';
                    if (_dom && _dom.querySelector('.active')) {
                        currencyCode = _dom.querySelector('.active').getAttribute('data-currency');
                    }

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }
            }

            if(this.skuProp && currentVariant && currentVariant.sku){
                this.skuProp.style.display = 'block';
                this.skuProp.querySelector('.productView-info-value').textContent = currentVariant.sku;
            }

            productForms.forEach((productForm) => {
                const input = productForm.querySelector('input[name="id"]');
                if (currentVariant) {
                    input.value = currentVariant.id;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.getAttribute('data-json'));

        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = quantityInput && parseInt(quantityInput.dataset.inventoryQuantity);
        var inputValue = quantityInput && parseInt(quantityInput.value);

        let value = inputValue

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1

        quantityInput.value = value

        document.getElementById('product-add-to-cart').dataset.available = this.currentVariant.available && maxValue <= 0
    }
}

customElements.define('variant-quick-view-selects', VariantQuickViewSelects);

class VariantQuickViewRadios extends VariantQuickViewSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));

        this.options = fieldsets.map((fieldset) => {
            var values = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
            return values ? values.value : null;
        });
    }
}

customElements.define('variant-quick-view-radios', VariantQuickViewRadios);

class QuantityQuickViewInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onInputChange(event) {
        event.preventDefault();
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = '';
        var _dom = document.getElementById(`product-quick-view-form-${this.input.dataset.product}`);
        if (_dom && _dom.querySelector('[name="id"]')) {
            currentId = _dom.querySelector('[name="id"]').value
        }
        var saleOutStock  = document.getElementById('product-add-to-cart').dataset.available === 'true' || false ;
        var addButtonDom = document.getElementById(`product-quick-view-form-${this.input.dataset.product}`);
        const addButton = addButtonDom && addButtonDom.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }

        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `quick_view_selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];

            if(itemStatus == 'deny') {
                inputValue = maxValue
                this.input.value =  inputValue;
                const message = getInputMessage(maxValue);
                showWarning(message, 3000);
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue === 0) {
            this.input.value = inputValue;
        }

        this.input.value =  inputValue;
        document.querySelectorAll('quantity-quick-view-input input[name="quantity"]').forEach(input => {
            if (this.input != input) input.value = inputValue
        })

        const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            mainQty.value = inputValue;

        if(window.quick_view_subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            var parser = new DOMParser();

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
            moneySpan.innerText = subTotal
            document.body.appendChild(moneySpan)

            if (this.checkNeedToConvertCurrency()) {
                var _dom = document.getElementById('currencies');
                let currencyCode = '';
                if (_dom && _dom.querySelector('.active')) {
                    currencyCode = _dom.querySelector('.active').getAttribute('data-currency');
                }
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText
            $(moneySpan).remove()
            const pdView_subTotal = document.querySelector('.quickView .productView-subtotal .money') || document.querySelector('.quickView .productView-subtotal .money-subtotal');
            pdView_subTotal.innerText = subTotal;
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
}

customElements.define('quantity-quick-view-input', QuantityQuickViewInput);

// details-disclosure.js
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp);
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.focus();
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open')
    }
}

customElements.define('details-disclosure', DetailsDisclosure);
